import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BaseNavComponent } from './base-nav.component';
import { MobileNavComponent } from './mobile-nav/mobile-nav.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';

@Component({
  selector: 'stx-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NavBarComponent, MobileNavComponent]
})
export class NavigationComponent extends BaseNavComponent {
  private breakpointObserver = inject(BreakpointObserver);

  greaterThanSmall: boolean;

  constructor() {
    super();
    this.observeViewport();
  }

  private observeViewport() {
    this.subSink.sink = this.breakpointObserver.observe('(min-width: 960px)').subscribe(result => {
      this.greaterThanSmall = result.matches;
      this.cd.detectChanges();
    });
  }
}
